class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-template').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value || 0), 0);

    this.debouncedOnChange = debounce((event) => this.onChange(event), 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id || '',
        selector: '.js-contents',
      },
      {
        id: 'cart-products-count',
        section: 'cart-products-count',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'cart-footer',
        section: document.getElementById('cart-footer')?.dataset.id || '',
        selector: '.js-contents',
      }
    ];
  }

  async updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    try {
      const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body });
      if (!response.ok) throw new Error(`Network response was not ok: ${response.status}`);

      const parsedState = await response.json();

      // Toggle cart visibility
      this.firstElementChild?.classList.toggle('hide', parsedState.item_count === 0);
      const cartEmpty = document.getElementById('cartEmpty');
      if (parsedState.item_count === 0 && cartEmpty) cartEmpty.classList.remove('hide');

      const cartFooter = document.getElementById('cart-footer');
      if (cartFooter) cartFooter.classList.toggle('hide', parsedState.item_count === 0);

      // Update sections safely
      this.getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container) return;

        const elementToReplace = container.querySelector(section.selector) || container;
        const htmlContent = parsedState.sections[section.section];
        if (htmlContent) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(htmlContent, section.selector);
        }
      });

      // Update live regions
      this.updateLiveRegions(line, parsedState.item_count);

      // Keep focus on the updated input
      const lineItem = document.getElementById(`CartItem-${line}`);
      const input = lineItem?.querySelector(`[name="${name}"]`);
      if (input) input.focus();

    } catch (err) {
      console.error('Cart update failed:', err);
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      const cartErrors = document.getElementById('cart-errors');
      if (cartErrors) cartErrors.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading();
    }
  }

  updateLiveRegions(line, itemCount) {
    try {
      if (this.currentItemCount === itemCount) {
        const lineError = document.getElementById(`Line-item-error-${line}`);
        const errorText = lineError?.querySelector('.cart-item__error-text');
        if (errorText) {
          errorText.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`)?.value || '0'
          );
        }
      }

      this.currentItemCount = itemCount;

      this.lineItemStatusElement?.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-live-region-text');
      if (cartStatus) {
        cartStatus.setAttribute('aria-hidden', false);
        setTimeout(() => {
          cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
      }
    } catch (e) {
      console.error('Failed to update live regions:', e);
    }
  }

  getSectionInnerHTML(html, selector) {
    if (!html) return '';

    try {
      const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
      const element = parsedDocument.querySelector(selector);
      return element ? element.innerHTML : '';
    } catch (e) {
      console.error('Failed to parse section HTML:', e, html);
      return '';
    }
  }

  enableLoading(line) {
    document.getElementById('main-cart-items')?.classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement?.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items')?.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-template', CartItems);
